export interface InitialTypeFilter {
  type: Array<{ item_id: string; item_text: string }>;
  hasFreeRoll: boolean;
  zeroBuyIn: boolean;
}

const freeroll = [{ item_id: "Freeroll", item_text: "Freeroll" }];
const regular = [{ item_id: "Regular", item_text: "Regular" }];

export function resolveInitialTypeFilter(mode: string, blocked: boolean): InitialTypeFilter {
  if (blocked && mode === "stats") {
    return { type: freeroll, hasFreeRoll: true, zeroBuyIn: true };
  }

  return {
    type: mode === "tournaments" ? regular : [],
    hasFreeRoll: blocked,
    zeroBuyIn: blocked,
  };
}
